module.exports = __webpack_public_path__ + "img/73.98b2981c.png";